import { getNextTagName, setHeadingStyle } from "./heading.helper";

export class headingCommand {
  constructor(editor) {
    this.editor = editor;
  }

  execute() {
    const selection = this.editor.selection;
    const blocks = selection.getSelectedBlocks();

    if (!blocks || blocks.length === 0) {
      return;
    }

    const nextTagName = getNextTagName({ blocks });

    // Filter out list items and blockquotes
    const selectedBlocksLis = Array.from(blocks).filter(
      (block) => block.nodeName.toLowerCase() === 'li'
    );
    const selectedBlocksQuote = Array.from(blocks).filter(
      (block) => this.getParentOuter(block)?.nodeName.toLowerCase() === 'blockquote'
    );

    if (selectedBlocksLis.length > 0 || selectedBlocksQuote.length > 0) {
      return;
    }

    const selectedBlocks = Array.from(blocks).filter(
      (block) => block.nodeName.toLowerCase() !== 'li'
    );

    if (!nextTagName) {
      return;
    }

    // Save selection trước khi modify DOM
    const savedSelection = selection.save();

    selectedBlocks.forEach((block) => {
      const parent = block.parentNode;
      if (!parent) return;

      // Tạo heading mới
      const newHeading = document.createElement(nextTagName);

      // Apply style cho heading
      setHeadingStyle(newHeading);

      // Move tất cả children từ block sang heading
      while (block.firstChild) {
        newHeading.appendChild(block.firstChild);
      }

      // Replace block bằng heading
      parent.insertBefore(newHeading, block);
      parent.removeChild(block);
    });

    // Restore selection sau khi modify DOM
    selection.restore(savedSelection);
  }

  getParentOuter(node) {
    let current = node;

    while (current && current.parentElement) {
      if (current.parentElement.tagName.toLowerCase() === 'div') {
        return current;
      }
      current = current.parentElement;
    }

    return null;
  }
}
